import { useState } from "react"
import { StepWizard, Wizard } from "../../bpm/config/Componentes/wizard/Wizard"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BudgetObligationForm } from "./BudgetObligationForm"
import { RegisterObligation } from "./RegisterObligation"
import { CreateObligationDocument } from "./CreateObligationDocument"
import { PrintJson } from "../../theme/Component/PrintJson"

interface MapProperties {
    FormData: Record<string, any>;
    ObjectList: object[];
    DocumentList: Record<string, any>;
}

export const BudgetObligationFactory = () => {

    const [rpDocument, setRPDocument] = useState<any>({})
    const [obligationList, setObligationList] = useState<any>({});

    const [canDiscard, setCanDiscard] = useState<boolean>(false);
    const [map, setMap] = useState<MapProperties>({
        FormData: {},
        ObjectList: [],
        DocumentList: {}
    });

    const steps: StepWizard[] = [
        {
            keyID: "0",
            name: 'PASO 1. Formulario',
            onEvent: () => { },
            children: <BudgetObligationForm onChange={(e) => { setMap({ ...map, "FormData": e }) }} />,
            validButton: (map.FormData.RPList?.length>0),
            canReturn: false
        },
        {
            keyID: "1",
            name: 'PASO 2. Compromisos Presupuestales a Obligar',
            onEvent: () => { },
            children: <RegisterObligation onChange={(e) => { setMap({ ...map, "ObjectList": e }) }} formData={map.FormData} />,
            validButton: (map.ObjectList.length>0),
            canReturn: true
        },
        {
            keyID: "2",
            name: 'PASO 3. Crear Obligación Presupuestal',
            onEvent: () => { },
            children: <CreateObligationDocument formData={map.FormData} objectList={map.ObjectList} onChange={()=>{}}  />,
            validButton: false,
            canReturn: false
        }
    ]
    return (
        <BasicPage titulo="Generar Obligación Presupuestal">
            <Wizard title="Certificado" listStep={steps} />
            {/* <PrintJson json={map}/> */}
        </BasicPage>
    )
}